import { render } from "./ArticleListPage.vue?vue&type=template&id=31f44088&scoped=true"
import script from "./ArticleListPage.vue?vue&type=script&lang=js"
export * from "./ArticleListPage.vue?vue&type=script&lang=js"

import "./ArticleListPage.vue?vue&type=style&index=0&id=31f44088&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f44088"]])

export default __exports__